import { Configuration, RedirectRequest } from '@azure/msal-browser';

const clientId = process.env.REACT_APP_AZURE_AD_CLIENT_ID || '';
const tenantId = process.env.REACT_APP_AZURE_AD_TENANT_ID || '';

// Custom API scope exposed by our backend app registration. This is what the backend
// validates as `aud`. Falls back to the standard pattern if the env var is unset.
const apiScope =
  process.env.REACT_APP_AZURE_AD_API_SCOPE ||
  (clientId ? `api://${clientId}/access_as_user` : '');

export const isAzureAdConfigured = Boolean(clientId);

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Used for both initial sign-in and silent token acquisition so the resulting
// access token is already audience-correct for our API.
export const loginRequest: RedirectRequest = {
  scopes: apiScope ? [apiScope] : [],
};

export const apiTokenRequest = loginRequest;
